
// Módulos
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { NgxMaskModule } from 'ngx-mask';

//componentes
import { ModalImagenComponent } from './modal-imagen/modal-imagen.component';
import { ModalRegularizarComponent } from './modal-regularizar/modal-regularizar.component';
import { ModalPdfComponent } from './modal-pdf/modal-pdf.component';
import { ModalFactSalidaComponent } from './modal-fact-salida/modal-fact-salida.component';
import { ModalFactEntradaComponent } from './modal-fact-entrada/modal-fact-entrada.component';
import { ModalPedidoCabeceraComponent } from './modal-pedido-cabecera/modal-pedido-cabecera.component';
import { ModalPedidoAvisosComponent } from './modal-pedido-avisos/modal-pedido-avisos.component';
import { ModalRecogidaModifComponent } from './modal-recogida-modif/modal-recogida-modif';
import { ModalPedidoOrigenComponent } from './modal-pedido-origen/modal-pedido-origen.component';


@NgModule({
  declarations: [
    ModalImagenComponent,
    ModalPdfComponent,
    ModalRegularizarComponent,
    ModalFactSalidaComponent,
    ModalFactEntradaComponent,
    ModalPedidoCabeceraComponent,
    ModalPedidoAvisosComponent,
    ModalRecogidaModifComponent,
    ModalPedidoOrigenComponent,
  ],
  exports: [
    ModalImagenComponent,
    ModalPdfComponent,
    ModalRegularizarComponent,
    ModalFactSalidaComponent,
    ModalFactEntradaComponent,
    ModalPedidoCabeceraComponent,
    ModalPedidoAvisosComponent,
    ModalRecogidaModifComponent,
    ModalPedidoOrigenComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NgxMaskModule.forRoot(),
  ]
})
export class ComponentesModule { }
